import type { ReactNode } from 'react';
import MediaCard from '@/components/feature/MediaCard';
import type { MediaItem } from '@/types/media';

interface MediaGridProps {
  items: MediaItem[];
  showType?: boolean;
  emptyText?: string;
  emptyAction?: ReactNode;
  className?: string;
}

export default function MediaGrid({
  items,
  showType = false,
  emptyText = '暂无匹配影视资源',
  emptyAction,
  className = 'grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 md:gap-5',
}: MediaGridProps) {
  if (!items.length) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-background-200/70 bg-background-100 py-16 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
          <i className="ri-inbox-line text-2xl"></i>
        </span>
        <p className="mt-4 text-sm text-foreground-600">{emptyText}</p>
        {emptyAction ? <div className="mt-4">{emptyAction}</div> : null}
      </div>
    );
  }

  return (
    <div className={className}>
      {items.map((item) => (
        <MediaCard key={item.id} item={item} showType={showType} />
      ))}
    </div>
  );
}